<template>
  <div>
    <nav class="nav-side d-flex flex-column justify-content-between align-items-center">
      <div class="nav-name-wrapper vertical-text">
        <a href="https://www.lamaisonannecy.com" class="menu-name">
          <div class="neonText">La Maison</div>
        </a>
      </div>
      <div class="nav-some_wrapper">
        <a href="https://www.instagram.com/lamaison_annecy/" target="_blank" class="social-link">
          <img src="@/assets/instagram.svg" alt="Instagram logo">
        </a>
      </div>
    </nav>
    <main class="content flex-grow-1 d-flex flex-column" id="top">
      <nav class="navbar nav-top d-flex justify-content-around align-items-center p-0">
        <a class="nav-item nav-link" href="#menus">Menus</a>
        <div class="separator"></div>
        <a class="nav-item nav-link" href="#bar">Bar</a>
        <div class="separator"></div>
        <a class="nav-item nav-link" href="#salle">Salle</a>
        <div class="separator"></div>
        <a class="nav-item nav-link" href="#terrasse">Terrasse</a>
        <div class="separator"></div>
        <a class="nav-item nav-link" href="#evenements">Évenements</a>
        <div class="separator"></div>
        <a class="nav-item nav-link" href="#contact">Contact</a>
      </nav>
      <div class="main-content flex-grow-1 d-flex video-section">
        <div class="content-text d-flex align-items-center justify-content-center" style="flex: 2;">
          <div class="hero-content">
            <h1 class="neonText bigneon">La Maison</h1>
            <h2>L'expérience culinaire au cœur d'Annecy</h2>
            <p>Situé au cœur de la vieille ville d'Annecy, La Maison vous invite à découvrir une cuisine raffinée et innovante dans une ambiance florale. Notre chef talentueux crée des plats qui allient tradition et modernité, utilisant les ingrédients les plus frais pour garantir une expérience gustative exceptionnelle.</p>
          </div>
        </div>
        <div class="content-video lineleft">
          <div class="video-wrapper">
            <iframe src="https://player.vimeo.com/video/994710336?h=62fd40cff0&autoplay=1&loop=1&muted=1&background=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
      <div class="main-content flex-grow-1 d-flex linetop linebottom">
        <div class="content-text d-flex align-items-center justify-content-center motif-section" style="flex: 1; padding:0; overflow:hidden; height:6rem;">
          <div class="scroll-text">
            Restaurant & bar ouvert 7J/7 de 11h à 2h
          </div>
        </div>
      </div>
      <div class="main-content flex-grow-1 d-flex linebottom" id="menus">
        <div class="content-image lineright">
          <img src="@/assets/photos/photos2025/food/plats-table.png" alt="La Maison Menus">
        </div>
        <div class="content-text d-flex align-items-center justify-content-center orderchangemobile" style="flex: 2;">
          <MenusPage />
        </div>
      </div>
      <div class="main-content flex-grow-1 d-flex linebottom scroll-section">
        <div class="content-text d-flex align-items-center justify-content-center" style="flex: 1; padding:0; overflow:hidden; height:6rem;">
          <div class="scroll-text">
            menu du marché <span class="price-text">23€</span> <span class="details-text">(entrée + plat + dessert, midi du lundi au vendredi)</span>
          </div>
        </div>
      </div>
      <div class="main-content flex-grow-1 d-flex" id="bar">
        <div class="content-text d-flex align-items-center justify-content-center" style="flex: 2;">
          <div>
            <h1 class="display-1">Bar</h1>
            <p>Notre bar vous propose une sélection de cocktails créatifs, de vins fins et de boissons rafraîchissantes. Laissez-vous séduire par nos créations uniques et profitez d'un moment de détente dans une ambiance conviviale.</p>
          </div>
        </div>
        <div class="content-image portrait-image lineleft orderchangemobile">
          <img src="@/assets/photos/photos2025/P1177763.jpg" alt="La Maison Bar">
        </div>
      </div>
      <div class="main-content flex-grow-1 d-flex linetop" id="salle">
        <div class="content-image lineright">
          <img src="@/assets/photos/photos2025/P1177734.jpg" alt="La Maison Salle">
        </div>
        <div class="content-text d-flex align-items-center justify-content-center" style="flex: 2;">
          <div>
            <h1 class="display-1">Salle</h1>
            <p>La salle de La Maison vous accueille dans un cadre élégant et raffiné, parfait pour une soirée intime ou un dîner festif entre amis. Profitez d'un service impeccable et d'une ambiance chaleureuse pour un moment inoubliable.</p>
          </div>
        </div>
      </div>
      <div class="main-content flex-grow-1 d-flex linetop" id="terrasse">
        <div class="content-text d-flex align-items-center justify-content-center" style="flex: 2;">
          <div>
            <h1 class="display-1">Terrasse</h1>
            <p>La terrasse de La Maison est l'endroit idéal pour profiter des beaux jours tout en dégustant nos délicieuses créations culinaires. Avec une vue imprenable sur la vieille ville d'Annecy, c'est l'endroit parfait pour un déjeuner en plein air ou un dîner sous les étoiles.</p>
          </div>
        </div>
        <div class="content-image lineleft orderchangemobile">
          <img src="@/assets/photos/photos2025/P1188225.jpg" alt="La Maison Terrasse">
        </div>
      </div>
      <div class="main-content flex-grow-1 d-flex linetop" id="evenements">
        <div class="content-image lineright">
          <img src="@/assets/photos/20240615-PhoenixSoiree-20.jpg" alt="La Maison Evenements">
        </div>
        <div class="content-text d-flex align-items-center justify-content-center" style="flex: 2;">
          <div>
            <h1 class="display-1">Évenements</h1>
            <p>Nous organisons divers événements tout au long de l'année, des soirées thématiques aux dégustations exclusives. Rejoignez-nous pour des moments mémorables, remplis de bonne humeur et de découvertes culinaires.</p>
          </div>
        </div>
      </div>
      <div class="main-content flex-grow-1 d-flex">
        <div class="content-text d-flex align-items-center justify-content-center" style="flex: 1; padding:0;">
          <iframe src="https://cdn.lightwidget.com/widgets/6293389b7c355c47ae8b7d471acb2092.html" scrolling="no" allowtransparency="true" class="lightwidget-widget" style="width:100%;border:0;overflow:hidden;"></iframe>
        </div>
      </div>
      <footer class="footer" id="contact" style="padding:0 !important;">
        <div class="infos-container">
          <p>Restaurant 7j/7</p>
          <p>Service midi 12h à 14h15</p>
          <p>Service soir 19h à 22h</p>
          <p>Bar 7j/7 de 11h à 2h</p>
          <br>
          <p>reservations@lamaisonannecy.com</p>
          <p>contact@lamaisonannecy.com</p>
          <p>04 50 02 63 99</p>
          <p>2A Quai Perrière</p>
          <p>74000 Annecy</p>
        </div>
        <div class="map-container">
          <iframe 
            class="styled-map"
            src="https://www.google.com/maps/embed/v1/place?key=AIzaSyA8H1eJWSy9YOkgv4d5gib98M2MtHJU5qU&zoom=15&q=La+Maison,1+Quai+Perrière,74000+Annecy"
            allowfullscreen
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
      </footer>
      <div style="text-align: center; font-size: 0.8em;" class="notebas">
        <p><a href="www.lamaisonannecy.com" style="color:black;">www.lamaisonannecy.com</a> | © 2023-{{ currentYear }} Tous droits réservés. | Développé par <a href="www.thecompagnie.eu" target="_blank" style="color:black;">TheCompagnie</a></p>
      </div>
    </main>
  </div>
  <!-- Zenchef Widget Configuration -->
  <div class="zc-widget-config" 
       data-restaurant="364568"
       data-token="45843dc4-4073-41fe-89e9-2a335a94813f"
       data-locale="fr"
       data-theme="light"></div>
</template>

<script>

import MenusPage from './MenusPage.vue';

export default {
  name: 'HomePage',
  components: {
    MenusPage
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },
  mounted() {
    // Initialize Zenchef widget after component is mounted
    this.initZenchefWidget();
  },
  methods: {
    initZenchefWidget() {
      // Wait for Zenchef SDK to load
      const checkZenchef = setInterval(() => {
        if (window.Zenchef) {
          clearInterval(checkZenchef);
          console.log('Zenchef SDK loaded successfully');
          // Trigger widget initialization
          if (window.Zenchef.init) {
            window.Zenchef.init();
          }
        }
      }, 100);
      
      // Clear interval after 10 seconds if not loaded
      setTimeout(() => clearInterval(checkZenchef), 10000);
    }
  }
};
</script>

<style scoped>

@font-face {
  font-family: 'Adventures Unlimited';
  src: local('Adventures Unlimited Script Bold'), local('Adventures-Unlimited-Script-Bold'),
      url('../assets/fonts/AdventuresUnlimited-ScriptBold.woff2') format('woff2'),
      url('../assets/fonts/AdventuresUnlimited-ScriptBold.woff') format('woff'),
      url('../assets/fonts/AdventuresUnlimited-ScriptBold.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
}

@import url('https://fonts.googleapis.com/css2?family=Fjalla+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Merriweather+Sans:ital,wght@0..900;1..900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Gotham:wght@100..900&display=swap');

body, html, #app {
  height: 100%;
  margin: 0;
  background-color: #fbecd2; /* Light background color */
  color: #1a1a1a; /* Dark text color */
  overflow-x: hidden; /* Prevent horizontal scroll */
  font-family: 'Gotham', sans-serif;
}

h1 {
  font-family: 'Fjalla One', sans-serif;
  font-weight: 700;
  text-transform: uppercase;
}

h2 {
  font-family: 'Fjalla One', sans-serif;
  text-transform: uppercase;
  font-weight: 700;
}

.map-container {
  position: relative;
  width: 100%;
  border-left: 1px solid #1a1a1a; /* Dark border color */
  display: flex; /* Assure que l'iframe prend toute la hauteur */
}

.styled-map {
  width: 100%;
  height: 100%; /* Prend toute la hauteur de son conteneur */
  flex: 1; /* Assure que l'iframe remplit entièrement la div */
  border: 0;
}

.infos-container{
  padding: 6rem;
}

.notebas {
    margin-bottom: 2rem;
    margin-top: 2rem;
  }
  
/* Ajustement Responsive */
@media (max-width: 768px) {
  .map-container {
    border-left: none; /* Supprime la bordure latérale */
  }

  .styled-map {
    height: 100%;
  }

  .infos-container{
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .map-container {
    border-left: none; /* Supprime la bordure latérale */
    border-top: 1px solid #1a1a1a; /* Dark border color */
  }

  .styled-map {
    height: 100%;
  }

  .infos-container{
    padding: 1rem;
  }
}


.neonText {
  font-family: 'Adventures Unlimited', cursive;
}

.nav-side {
  border-right: 1px solid #1a1a1a; /* Dark border color */
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 5.714rem;
  display: flex;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  padding: 1rem;
}

.vertical-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  transform: rotate(180deg);
  font-size: 3em;
}

.content {
  margin-left: 5.714rem;
  padding: 0;
  overflow-y: auto;
  min-height: 100vh; /* Ensure content takes full height */
  display: flex;
  flex-direction: column;
}

.nav-top {
  width: 100%;
  height: 4rem;
  border-bottom: 1px solid #1a1a1a; /* Dark border color */
  display: flex;
  align-items: center;
  padding: 0; /* Remove padding */
  font-weight: 400;
}

.nav-item {
  flex: 1;
  text-align: center;
  transition: background-color 0.3s ease;
}

/* Alternating hover colors for menu items */
.nav-item:nth-child(1):hover {
  background-color: #6f405f;
  color: #fbecd2;
}

.nav-item:nth-child(3):hover {
  background-color: #bd9c59;
  color: #fbecd2;
}

.nav-item:nth-child(5):hover {
  background-color: #652e2a;
  color: #fbecd2;
}

.nav-item:nth-child(7):hover {
  background-color: #1a1a1a;
  color: #fbecd2;
}

.nav-item:nth-child(9):hover {
  background-color: #6f405f;
  color: #fbecd2;
}

.nav-item:nth-child(11):hover {
  background-color: #bd9c59;
  color: #fbecd2;
}

.nav-link {
  font-family: 'Fjalla One', sans-serif;
  color: #1a1a1a; /* Dark text color */
  text-align: center;
  display: flex;
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  font-size: 1rem;
  width: 100%;
  height: 100%;
  text-transform: uppercase;
}

.separator {
  width: 1px;
  height: 100%;
  background-color: #1a1a1a; /* Dark separator color */
}

.main-content {
  display: flex;
  flex-grow: 1;
}

.content-text {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.content-image, .content-video {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  max-height: 70vh; /* Limite la hauteur maximale à 70% de la hauteur de viewport */
}

.content-image.portrait-image {
  flex: 1; /* Même proportion que les autres images */
  max-width: 33.33%; /* Limite la largeur pour les images portrait (1/3 de la section) */
  max-height: 50vh; /* Hauteur réduite pour les images verticales */
}

.content-image img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center; /* Centre l'image dans son conteneur */
}

.content-video {
  max-height: 60vh;
}

.content-video iframe {
  pointer-events: none; /* Prevent interaction with the video */
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensure the video covers the container */
}

.video-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 177.78%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.lineright {
  border-right: 1px solid #1a1a1a; /* Dark border color */
}

.lineleft {
  border-left: 1px solid #1a1a1a; /* Dark border color */
}

.linetop {
  border-top: 1px solid #1a1a1a; /* Dark border color */
}

.linebottom {
  border-bottom: 1px solid #1a1a1a; /* Dark border color */
}

.footer {
  color: #1a1a1a; /* Dark text color */
  padding: 0;
  display: flex;
  justify-content: space-between;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  border-bottom: 1px solid #1a1a1a; /* Dark border color */
}

.footer p {
  margin: 0.5rem 0;
}

a {
  text-decoration: none !important;
}

.neonText {
  color: #1a1a1a; /* Dark text color */
  font-family: 'Adventures Unlimited', cursive;
  cursor: pointer;
  width: fit-content;
  text-transform: none !important;
}

.neonText:hover {
  color: #fff;
  text-shadow:
    0 0 2px #fff,
    0 0 10px #fff,
    0 0 21px #fff,
    0 0 42px #fff,
    0 0 82px #fff,
    0 0 92px #fff,
    0 0 102px #fff,
    0 0 151px #fff;
}

.nav-name-wrapper{
  margin-top: 0.5em;
}

.nav-some_wrapper{
  margin-bottom: 1em;
}

.bigneon{
  font-size: 10rem;
}

.scroll-text {
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  animation: scroll 20s linear infinite;
  color: #fbecd2;
  font-weight: 700;
  font-size: 3.5rem;
  font-family: 'Fjalla One', sans-serif;
  letter-spacing: 0.05em;
  line-height: 1;
}

.price-text {
  font-family: 'Merriweather Sans', sans-serif;
  font-weight: 300;
  font-style: italic;
  display: inline-flex;
  align-items: center;
  padding-left: 1rem;
}

.details-text {
  font-size: 1.8rem;
  font-weight: 400;
  font-family: 'Gotham', sans-serif;
  display: inline-flex;
  align-items: center;
  padding-left: 1rem;
}

.scroll-section {
  background-color: #652e2a;
}

.motif-section {
  background-color: #bd9c59;
}

@keyframes scroll {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}

.subtitle {
  font-family: 'Merriweather Sans', sans-serif;
  font-weight: 300;
  font-style: italic;
}

/* Responsive Styles */
@media (max-width: 1210px) {

  .vertical-text {
    font-size: 2.5em;
  }

  .bigneon{
    font-size: 5em;
  }

  .nav-top {
    height: 3rem;
  }

  h1{
    font-size: 3em;
  }

  h2{
    font-size: 1.6em;
  }

  .nav-link {
    font-size: 0.9rem;
  }

}

@media (max-width: 610px) {
  .orderchangemobile{
    order: -1;
  }

  .nav-side {
    width:3em;
  }

  .nav-top {
    flex-direction: column;
    height: auto;
  }

  .nav-link {
    padding: 0.5rem 0;
  }

  .separator {
    display: none;
  }

  .main-content {
    flex-direction: column;
  }

  .content-text {
    padding: rem;
  }

  /* Optimize scrolling text sections for mobile */
  .motif-section,
  .scroll-section .content-text {
    height: 5rem !important; /* Slightly smaller on mobile */
  }

  .scroll-text {
    font-size: 2rem !important; /* Reduce main text size */
  }

  .price-text {
    font-size: 2rem !important; /* Proportional to main text */
  }

  .details-text {
    font-size: 1.2rem !important; /* Proportional to main text */
  }

  .content-image img {
    border-top: 1px solid #1a1a1a; /* Dark border color */
    border-bottom: 1px solid #1a1a1a; /* Dark border color */
    border-left: 0; /* Dark border color */
    border-right: 0; /* Dark border color */
  }

  .content-image.portrait-image {
    flex: 1; /* Sur mobile, les images portrait prennent toute la largeur */
    max-width: 100%;
  }

  .lineright {
    border-right: 0; /* Dark border color */
  }

  .lineleft {
    border-left: 0; /* Dark border color */
  }

  .linetop {
    border-top: 0; /* Dark border color */
  }

  .linebottom {
    border-bottom: 0; /* Dark border color */
  }

  .content{
    margin-left: 3em;
  }

  .bigneon {
    font-size: 5rem;
  }

  .lineleft{
    border: none;
  }

  .lineright{
    border: none;
  }

  .linetop{
    border: none;
  }

  .footer {
    flex-direction: column;
    text-align: center;
  }

  .notebas {
    margin-bottom: 2rem;
    margin-top: 2rem;
  }
}
</style>
